import React, {CSSProperties, MutableRefObject} from 'react';
import type {UniqueIdentifier} from '@dnd-kit/core';
import {AnimateLayoutChanges, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

import {TreeItem, Props as TreeItemProps} from './TreeItem.tsx';
import {iOS} from '../../utilities.ts';

interface Props extends TreeItemProps {
  id: UniqueIdentifier;
  insertNewItemAfter(ctrlCreate: boolean): void;  
  inputRef: MutableRefObject<null> | null;
  inputRefs: MutableRefObject<never[]> | null;
  index: number;
}

const animateLayoutChanges: AnimateLayoutChanges = ({isSorting, wasDragging}) =>
  isSorting || wasDragging ? false : true;

export const SortableTreeItem = React.memo(SortableTreeItemComponent);

function SortableTreeItemComponent({id, done, depth, goal, insertNewItemAfter, isMobile, handleOnSubmit, inputRef, inputRefs, index, ...props}: Props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges,
  });
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  function sortableTreeItemHandleOnfocus(ctrlCreate: boolean) {
    if(insertNewItemAfter){
      insertNewItemAfter(ctrlCreate);
    }
    
  }

  return (
    <TreeItem
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      inputRef={inputRef}
      inputRefs={inputRefs}
      index={index}
      isMobile={isMobile}
      style={style}
      done={done}
      depth={depth}
      ghost={isDragging}
      goal={goal}
      disableSelection={iOS}
      disableInteraction={isSorting}
      treeItemHandleOnfocus={sortableTreeItemHandleOnfocus}
      handleOnSubmit={handleOnSubmit}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      {...props}
    />
  );
}
